import React from "react";
import locale from "@bonliva-crm/locale";
import { useObserver } from "mobx-react";
import { Grid } from "@material-ui/core";
import { FormTab } from "@components/forms/common/FormTab";
import FormSection from "@components/forms/common/FormSection";
import { Text } from "@components/formx";
import ConsultantFormSection from "../components/Common/ConsultantFormSection";
import { WorkExperienceInfo } from "../sections/WorkExperienceInfo";
import { LanguageSkillsInfo } from "../sections/LanguageSkilsInfo";
import { EducationInfo } from "../sections/EducationInfo";
import { ConsultantEditorStore } from "../ConsultantEditorStore";
import { useConsultantEditorContext } from "../ConsultantEditorContext";

export function BackgroundTab() {
  const editorStore: ConsultantEditorStore = useConsultantEditorContext();
  return useObserver(() => (
    <FormTab horizontal>
      <FormSection fitted>
        <FormSection title={locale.Education} fullWidth>
          <EducationInfo />
        </FormSection>

        <FormSection title={locale.WorkExperience} fullWidth style={{ marginTop: 16 }}>
          <WorkExperienceInfo />
        </FormSection>
      </FormSection>

      <FormSection fitted>
        <ConsultantFormSection
          hasValidated={!editorStore.consultantCVManager.hasChangesInLanguagesSkillsInfo}
          colorSectionForNotApproved={true}
          validate={(e, c) => {
            if (c) {
              editorStore.consultantCVManager.approveKeyTemplate("languageSkills");
            }
          }}
          title={locale.Language}
          fullWidth
        >
          <LanguageSkillsInfo />
        </ConsultantFormSection>
        <ConsultantFormSection
          hasValidated={!editorStore.consultantCVManager.hasChangesInExtraCurriculum}
          colorSectionForNotApproved={true}
          validate={(e, c) => {
            if (c) {
              editorStore.consultantCVManager.approveKeyTemplate("extraCurriculum");
            }
          }}
          title={locale.ExtraCurriculum}
          fullWidth
          style={{ marginTop: 16 }}
        >
          <Grid item xs={12}>
            <Text
              name="extraCurriculum"
              TextFieldProps={{
                multiline: true,
                fullWidth: true
              }}
            />
          </Grid>
        </ConsultantFormSection>
      </FormSection>
    </FormTab>
  ));
}
